import { API_PREFIX } from '@/api/endpoints/api.constants';

const BASE = `${API_PREFIX}/site-menu`;

export const SITE_MENU_ENDPOINTS = {
  LIST:       `${BASE}/`,
  CREATE:     `${BASE}/`,
  DETAIL:     (id: number) => `${BASE}/${id}/`,
  UPDATE:     (id: number) => `${BASE}/${id}/`,
  DELETE:     (id: number) => `${BASE}/${id}/`,
  REORDER:    `${BASE}/reorder/`,
  USER_MENU:  `${BASE}/user-menu/`,
} as const;
